import {ChangeFunction} from '@hconnect/common/types'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {ApiPath} from '../../../../shared/consts'
import {useAxios} from '../../../../shared/hooks'
import {QueryKeyName} from '../../../consts'

export const useChangeFunctions = (
  options?: Omit<UseQueryOptions<ChangeFunction[], AxiosError>, 'queryKey' | 'queryFn'>
) => {
  const axiosInstance = useAxios()
  const {
    i18n: {language}
  } = useTranslation()
  const path = `${ApiPath.SHIFT_HANDOVER}/change-functions`

  return useQuery<ChangeFunction[], AxiosError>({
    queryKey: [QueryKeyName.ShifthandoverChangeFunctions, language],
    queryFn: async ({signal}) => {
      const {data} = await axiosInstance.get<ChangeFunction[]>(path, {signal})
      return data
    },
    ...options
  })
}
